module.exports = __webpack_public_path__ + "static/media/user-facebook.3163f277.svg";